import { EyeOutlined } from "@ant-design/icons";
import { Button } from "antd";

interface FilesCellProps {
  file: any;
  fileLoading: boolean;
  selectedSoNo: string | undefined;
  onOpen: (file: any) => void;
}

export function FilesCell({ file, fileLoading, selectedSoNo, onOpen }: FilesCellProps) {
  if (!(file.allowPdfDownload === undefined || file.allowPdfDownload)) {
    return null;
  }
  return (
    <Button
      disabled={fileLoading}
      loading={fileLoading && selectedSoNo === file.soNo}
      type="primary"
      icon={<EyeOutlined />}
      onClick={() => onOpen(file)}
    />
  );
}
